export default "__VITE_ASSET__C6W_frvL__"